import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { LegFinishMaterial, UpholsteryMaterial } from '../../utils/materials';

export function Paige_bench(props) {
  const { nodes, materials, scene } = useGLTF('models/Paige Bench.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    UpholsteryMaterial,
    currentMaterialFinish.upholsteryFinish,
    defaultFinish.upholsteryFinish,
    'ao-paige_bench-upholstery',
    aoIntensity,
  );
  useSetMaterialFinish(
    LegFinishMaterial,
    currentMaterialFinish.legFinish,
    defaultFinish.legFinish,
    'ao-paige_bench-leg_finish',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Upholstery.geometry}
        material={UpholsteryMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.Leg_Finish.geometry}
        material={LegFinishMaterial}
      />
      <Shadow model={'Paige Bench'} />
    </group>
  );
}
